/** Calendar arithmetic uses UTC; today's date always follows Rome. */
export const romeToday = () => new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Rome" }).format(new Date());
export const addDays = (value, count) => {
    const date = new Date(`${value}T12:00:00Z`);
    date.setUTCDate(date.getUTCDate() + count);
    return date.toISOString().slice(0, 10);
};
export const weekStart = value => addDays(value, -(new Date(`${value}T12:00:00Z`).getUTCDay() + 6) % 7);
export const weekDates = value => Array.from({ length: 7 }, (_, index) => addDays(weekStart(value), index));
export const validDate = value => typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) && Number.isFinite(Date.parse(`${value}T12:00:00Z`)) && new Date(`${value}T12:00:00Z`).toISOString().slice(0, 10) === value;
export const fullDate = value => new Date(`${value}T12:00:00Z`).toLocaleDateString("it-IT", { timeZone: "UTC", day: "numeric", month: "long", year: "numeric" });
export const coverageLabel = period => !Number.isFinite(period.hours) ? "Dati non disponibili" : period.complete ? "Dati completi" : "Dati parziali";
export function historyBounds(value, unit, weeks = 12) {
    if (unit === "monthly") {
        const month = new Date(`${value.slice(0, 7)}-01T12:00:00Z`);
        month.setUTCMonth(month.getUTCMonth() - 11);
        return { start: month.toISOString().slice(0, 10), end: value.slice(0, 7) + "-01" };
    }
    const endWeek = weekStart(value);
    return { start: addDays(endWeek, -7 * (weeks - 1)), end: addDays(endWeek, 6) };
}
export function selectedDate(query, view, today = romeToday()) {
    const monthly = ["andamento", "andamento-reparto"].includes(view) && query.unit === "monthly";
    const candidate = view === "giorno" ? query.date || query.week : monthly ? query.month : query.week;
    const value = validDate(candidate) ? candidate : today;
    const bounded = value > today ? today : value < addDays(today, -723) ? addDays(today, -723) : value;
    return view === "giorno" ? bounded : monthly ? bounded.slice(0, 7) + "-01" : weekStart(bounded);
}
export function cuttingLocation(view, value, unit = "weekly") {
    const query = view === "giorno" ? { date: value } : ["andamento", "andamento-reparto"].includes(view) && unit === "monthly" ? { month: value.slice(0, 7) + "-01", unit } : { week: weekStart(value) };
    return { path: `/laser/kpi/taglio/${view}/`, query };
}
export function weeklyComparison(report) {
    const selected = report.selected;
    const previous = report.weekly[report.weekly.length - 2];
    const available = Boolean(previous && !selected.provisional && !previous.provisional && selected.complete && previous.complete && Number.isFinite(selected.hours) && Number.isFinite(previous.hours));
    return { available, same_time: false, start: previous?.start, end: previous?.end, hours: available ? previous.hours : null, delta_hours: available ? Math.round((selected.hours - previous.hours) * 100) / 100 : null,
        reason: selected.provisional ? "Confronto disponibile a settimana conclusa, con dati completi." : "Dati incompleti: confronto non valutabile." };
}
